import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import { allowOnlyNumberKeys } from '../../utils';
import { commonDollarPriceInputProps } from '../../commonProps';
import { type DollarPriceInputProps } from '@wix/da-shared-react/pkg/DollarPriceInput';

export interface Props extends Omit<DollarPriceInputProps, 'name' | 'onChange' | 'value'> {
  name: string;
  /** only allow 0-9 */
  onlyNumberKeys?: boolean;
  onChange?: (value: string, errorMessage?: string) => void;
  render: (props: DollarPriceInputProps, inputState) => any;
}

const DollarInputController: React.FC<Props> = ({
  name,
  render,
  isRequired,
  onlyNumberKeys,
  onChange,
  ...rest
}) => {
  const { t } = useTranslation();
  const { control, errors } = useFormContext();

  const errMsg =
    errors[name]?.type === 'required' ? t('sellerModal.error.required') : errors[name]?.message;

  return (
    <Controller
      control={control}
      name={name}
      rules={{ required: isRequired }}
      render={({ onChange: controllerOnChange, ...fieldProps }, inputState) =>
        render(
          {
            isRequired,
            error: errMsg,
            onKeyPress: onlyNumberKeys ? allowOnlyNumberKeys : undefined,
            onChange: v => {
              controllerOnChange(v);
              onChange && onChange(v);
            },
            ...fieldProps,
            ...commonDollarPriceInputProps,
            ...rest,
          },
          inputState
        )
      }
    />
  );
};

DollarInputController.displayName = 'DollarInputController';

export default DollarInputController;
